import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import { useLanguage } from "../Translations/LenguageContext";

const LogoutModal = ({ show, handleClose, handleLogout, loadingLogout, userEmail }) => {
    const { t } = useLanguage()

    return (
        <Modal show={show} onHide={handleClose} centered className="logout_modal">
            <div className="logout_modal_body">
                <p className="logout_modal_body_title">{t.logout_modal.title}</p>
                <p className="logout_modal_body_desc">{t.logout_modal.subtitle} {userEmail}?</p>
            </div>

            <div className="modal_footer_logout">
                <button
                    className="modale_save_btn"
                    onClick={handleLogout}
                >
                    {loadingLogout ? <Spinner loading={true} /> : t.sidebar.logout}
                </button>

                <button className="modale_close_btn" onClick={handleClose}>
                    {t.cancel}
                </button>
            </div>
        </Modal>
    );
};

export default LogoutModal;